export default __webpack_public_path__ + "static/media/dynastypackage_2025.1b529ba9.jpg";